/** All child/parent-facing Vietnamese text (skill mb-vi-copy). Ong xưng "tớ", gọi bé "cậu". */
export const copy = {
  app: { name: "MathBee", tagline: "Học toán thật vui!" },
  welcome: {
    start: "Bắt đầu ngay",
    login: "Đăng nhập",
    note: "Dành cho học sinh lớp 2 · Theo chương trình Kết nối tri thức",
  },
  login: {
    title: "Bố mẹ đăng nhập",
    subtitle: "Đăng nhập một lần, sau đó bé chỉ cần chọn tên mình.",
    username: "Tên đăng nhập",
    password: "Mật khẩu",
    show: "Hiện",
    hide: "Ẩn",
    submit: "Đăng nhập",
    busy: "Đang đăng nhập…",
  },
  chooseChild: {
    title: "Ai đang học nhỉ?",
    level: (n: number) => `Cấp ${n}`,
    grade: (n: number) => `Lớp ${n}`,
    stars: (n: number) => `${n} sao`,
    logout: "Đăng xuất",
    empty: "Chưa có hồ sơ của bé. Bố mẹ hãy nhờ quản trị tạo hồ sơ nhé.",
  },
  nav: {
    home: "Trang chủ",
    practice: "Luyện tập",
    achievements: "Thành tích",
    leaderboard: "Xếp hạng",
    shop: "Cửa hàng",
    switchChild: "Đổi người học",
  },
  home: {
    greeting: (name: string) => `Xin chào ${name}!`,
    greetingSub: "Hôm nay cậu muốn chinh phục hòn đảo nào?",
    volume: (v: number) => `Tập ${v}`,
    islandStars: (got: number, max: number) => `${got}/${max}`,
    comingSoonIsland: "Sắp mở",
    islandLocked: "Xong đảo trước là mở",
    lessonLocked: "Cậu cần ít nhất 1 sao ở bài trước để mở bài này nhé!",
    lessonLockedLabel: "chưa mở",
    /** C15 daily quests (SPEC 7.7, T2.9b) */
    /** weekly leaderboard prize (D44), told once on the home screen */
    prize: {
      title: "Tin vui từ bảng xếp hạng!",
      line: (rank: number, board: string, coins: number) =>
        `Tuần trước cậu ${rank === 1 ? "đứng đầu" : `đứng thứ ${rank}`} ở bảng ${board}. Tớ tặng cậu ${coins} xu!`,
      ok: "Tuyệt quá!",
    },
    quests: {
      title: "Nhiệm vụ hôm nay",
      sub: "Xong cả 3 nhiệm vụ là mở được rương quà!",
      allDone: "Cậu đã mở rương hôm nay rồi. Mai lại có nhiệm vụ mới nhé!",
      progress: (n: number, of: number) => `${n}/${of}`,
      doneLabel: (title: string) => `${title}: đã xong`,
      leftLabel: (title: string, n: number, of: number) => `${title}: ${n} trên ${of}`,
    },
    continueTitle: "Học tiếp nào!",
    continueCta: "Vào học",
    lessonsOf: (n: number) => `Chủ đề ${n}`,
    boss: {
      title: "Thử thách đảo",
      open: "10 câu trộn cả đảo. Vượt qua để nhận Cúp đảo!",
      locked: "Mỗi bài của đảo đạt ít nhất 1 sao là mở nhé!",
      won: "Cậu đã có Cúp đảo này!",
      trophyLabel: "Có cúp đảo",
      empty: "Đảo này chưa có câu hỏi cho Thử thách đảo.",
    },
  },
  lesson: {
    number: (n: number) => `Bài ${n}`,
    comingSoon: "Sắp có",
    comingSoonText: "Bài này đang được MathBee chuẩn bị. Cậu học bài khác trước nhé!",
    lockedText: "Bài này chưa mở đâu! Cậu đạt ít nhất 1 sao ở bài trước là tớ mở ngay.",
    steps: {
      intro: { title: "Khám phá cùng Ong", text: "Xem tớ giải mẫu nhé" },
      practice: { title: "Luyện tập", text: "8 câu, nhận sao và xu" },
      notebook: { title: "Vở ô li", text: "Tập trình bày bài giải" },
      challenge: { title: "Thử thách", text: "5 câu đố tư duy · không bắt buộc" },
      activity: { title: "Thực hành ngoài đời", text: "Làm cùng bố mẹ, nhận điểm kinh nghiệm" },
    },
    activityCount: (done: number, all: number) => `Đã làm ${done}/${all}`,
    activityOpen: "Xem",
    brainMark: "Đã chinh phục thử thách",
    start: "Bắt đầu",
    again: "Làm lại",
    done: "Đã xong",
    notebookLevel: "Cách làm vở ô li",
    notebookLevels: { 1: "Chọn câu", 2: "Xếp chữ", 3: "Tự viết" } as Record<1 | 2 | 3, string>,
    notebookLocked: (name: string) => `${name} (chưa mở)`,
    /** SPEC 5.6: what opens the next level */
    notebookToNext: (now: string, next: string) =>
      `Làm cách "${now}" được từ 2 sao là mở cách "${next}".`,
    notebookFixed: "Bố mẹ đã chọn cách làm này cho cậu.",
    beeTip: "Cậu xem phần Khám phá trước rồi hãy luyện tập nhé!",
    game: { text: "Chơi với Ong, nhận xu", play: "Chơi" },
  },
  parent: {
    title: "Khu phụ huynh",
    entry: "Khu phụ huynh",
    back: "Chọn bé",
    gate: {
      lead: "Phần này dành cho bố mẹ. Bố mẹ trả lời giúp MathBee nhé:",
      question: (a: number, b: number) => `${a} × ${b} =`,
      answerLabel: "Kết quả",
      submit: "Vào khu phụ huynh",
      wrong: "Chưa đúng. Bố mẹ thử phép tính mới nhé.",
      loading: "Đang lấy phép tính…",
    },
    freeUnlock: {
      title: "Mở khoá tự do",
      on: "Đang bật: bé vào được mọi bài và mọi đảo, kể cả Thử thách đảo.",
      off: "Đang tắt: bài sau mở khi bài trước đạt ít nhất 1 sao; đảo sau mở khi xong đảo trước.",
    },
    leaderboard: {
      title: "Tham gia xếp hạng",
      on: "Đang bật: bé có tên trên bảng xếp hạng của nhà mình và các nhóm thi đua, top 3 mỗi tuần được thưởng xu.",
      off: "Đang tắt: bé không có tên trên bảng của ai; bé chỉ xem điểm kinh nghiệm của mình.",
    },
    sound: {
      title: "Âm thanh khen thưởng",
      on: "Đang bật: bé nghe tiếng vui khi làm đúng, xong lượt, lên cấp, nhận huy hiệu. Bé vẫn tự tắt được bằng nút hình chuông.",
      off: "Đang tắt: mặc định im lặng. Bé vẫn tự bật lại được bằng nút hình chuông.",
    },
    grade: {
      title: "Lớp học",
      label: (n: number) => `Lớp ${n}`,
      soon: "Sắp có",
      book: (title: string, series: string) => (series ? `${title} · ${series}` : title),
      keep: "Đổi lớp không mất bài đã học: sao, xu, huy hiệu vẫn giữ nguyên.",
    },
    /** T5.11: notebook input level (SPEC 5.6) */
    notebook: {
      title: "Cách làm vở ô li",
      options: [
        { value: null, label: "Tự mở dần" },
        { value: 1, label: "Chọn câu" },
        { value: 2, label: "Xếp chữ" },
        { value: 3, label: "Tự viết" },
      ] as { value: 1 | 2 | 3 | null; label: string }[],
      auto: "Ở mỗi bài, bé bắt đầu bằng cách chọn câu lời giải; làm được từ 2 sao thì mở cách xếp chữ, xếp chữ được từ 2 sao thì mở cách tự viết bằng bàn phím tiếng Việt.",
      fixed: "Bé chỉ làm vở ô li theo cách bố mẹ chọn.",
    },
  },
  sound: {
    turnOff: "Tắt âm thanh",
    turnOn: "Bật âm thanh",
  },
  practiceHub: {
    title: "Luyện tập",
    subtitle: "Mỗi ngày một chút, cậu sẽ nhớ thật lâu!",
    week: ["T2", "T3", "T4", "T5", "T6", "T7", "CN"],
    weekDone: " (đã học)",
    daily: {
      title: "Luyện tập hằng ngày",
      text: "5 câu trộn từ các bài cậu đã học",
      start: "Bắt đầu",
      more: "Làm thêm",
      doneToday: "Hôm nay cậu đã luyện tập rồi. Giỏi lắm!",
      doneShort: "Xong hôm nay",
      locked: "Học bài đầu tiên để mở Luyện tập hằng ngày nhé!",
      goLearn: "Vào học",
    },
    review: {
      title: "Ôn tập thông minh",
      due: (n: number) => `${n} câu cần ôn hôm nay`,
      none: "Cậu đã ôn xong hôm nay!",
      noneShort: "Đã ôn xong",
      /** nothing learned yet: no question can be due */
      notYet: "Cậu học vài bài, tớ sẽ nhắc ôn đúng lúc nhé!",
      notYetShort: "Chưa có câu",
      text: "Tớ nhắc lại những câu cậu còn chưa chắc",
      start: "Ôn ngay",
    },
    quick: {
      title: "Đấu nhanh",
      text: "Trả lời thật nhanh trong 60 giây",
      best: (n: number) => `Kỷ lục của cậu: ${n} câu đúng`,
      start: "Chơi ngay",
    },
    games: { title: "Trò chơi", text: "Vừa chơi vừa học" },
    soon: "Sắp ra mắt",
  },
  comingSoon: {
    title: "Sắp ra mắt",
    text: "Tớ đang chuẩn bị phần này. Cậu quay lại học trên bản đồ nhé!",
    back: "Về bản đồ",
  },
  errors: {
    generic: "Ối, có lỗi xảy ra. Cậu thử lại nhé.",
    retry: "Thử lại",
  },
};

/** Messages for engine mistake codes (SPEC §5.5) — tell the child how to fix, never blame. */
